"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Select = void 0;
var React = _interopRequireWildcard(require("react"));
var _utils = require("../utils");
var _ui = require("../../ui");
require("../../../src/ui/select/select.module.scss");
var _checkbox = require("../checkbox/checkbox");
var _uuid = require("uuid");
var _selectListItem = require("../selectListItem/selectListItem");
var _selectList = require("../selectList/selectList");
var _portal = require("../portal/portal");
var _excluded = ["active", "children", "className", "color", "directionVertical", "directionHorizontal", "disabled", "dropdownClassName", "editable", "isCloseOnClick", "isCloseOnEnter", "isFitWindow", "isDropdownUplifted", "isUpdateValueOnChange", "multiple", "notBlurClasses", "opened", "options", "portal", "portalId", "portalSelector", "readOnly", "single", "variant", "onActiveChange", "onBlur", "onChange", "onClick", "onEnter", "onFocus", "onKeyDown", "onOpen", "onClose"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
// accessibility ok

var UPLIFT_EXTRA_MARGIN = 12; // на сколько торчит Dropdown над Input

var Select = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var active = props.active,
    children = props.children,
    className = props.className,
    color = props.color,
    directionVertical = props.directionVertical,
    directionHorizontal = props.directionHorizontal,
    disabled = props.disabled,
    dropdownClassName = props.dropdownClassName,
    editable = props.editable,
    isCloseOnClick = props.isCloseOnClick,
    isCloseOnEnter = props.isCloseOnEnter,
    isFitWindow = props.isFitWindow,
    isDropdownUplifted = props.isDropdownUplifted,
    isUpdateValueOnChange = props.isUpdateValueOnChange,
    multiple = props.multiple,
    notBlurClasses = props.notBlurClasses,
    opened = props.opened,
    options = props.options,
    portal = props.portal,
    portalId = props.portalId,
    portalSelector = props.portalSelector,
    readOnly = props.readOnly,
    single = props.single,
    variant = props.variant,
    onActiveChange = props.onActiveChange,
    onBlur = props.onBlur,
    onChange = props.onChange,
    onClick = props.onClick,
    onEnter = props.onEnter,
    onFocus = props.onFocus,
    onKeyDown = props.onKeyDown,
    onOpen = props.onOpen,
    onClose = props.onClose,
    attributesOriginal = _objectWithoutProperties(props, _excluded),
    attributes = attributesOriginal,
    dropdownBody = null,
    list = [],
    isSearch = variant === 'search';

  // dont update search input value if not forced
  isUpdateValueOnChange = isUpdateValueOnChange === undefined ? !isSearch : isUpdateValueOnChange;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isScroll = _React$useState2[0],
    setScroll = _React$useState2[1];
  var _React$useState3 = React.useState(active),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    activeHook = _React$useState4[0],
    _setActiveHook = _React$useState4[1];
  var _React$useState5 = React.useState(directionVertical),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    directionHook = _React$useState6[0],
    setDirectionHook = _React$useState6[1];
  var _React$useState7 = React.useState(''),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    initialValue = _React$useState8[0],
    _setInitialValue = _React$useState8[1];
  var _React$useState9 = React.useState(''),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    valueHook = _React$useState10[0],
    setValueHook = _React$useState10[1];
  var _React$useState11 = React.useState(opened),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    isOpenedHook = _React$useState12[0],
    setIsOpenedHook = _React$useState12[1];
  var _React$useState13 = React.useState([]),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    itemsRefsHook = _React$useState14[0],
    setItemsRefsHook = _React$useState14[1]; // list items for auto scroll in dropdown
  var _React$useState15 = React.useState('kui-select--' + (0, _uuid.v4)()),
    _React$useState16 = _slicedToArray(_React$useState15, 1),
    uniqueClass = _React$useState16[0];
  var dropdownUniqueClass = 'kui-select__dropdown--' + uniqueClass;
  var dropdownRef = React.useRef(null);
  var inputRef = React.useRef(null);
  var selectRef = React.useRef(null);
  var combinedRef = (0, _utils.useCombinedRefs)(ref, selectRef);
  var timer = React.useRef(null);
  var isOpened = React.useRef(null);
  className = (0, _utils.ClassNames)('kui-select', uniqueClass, disabled ? 'kui-select--disabled' : null, isOpenedHook ? 'kui-select--opened' : null, variant ? 'kui-select--variant_' + variant : null, multiple && single ? 'kui-select--single' : null, readOnly ? 'kui-select--readonly' : null, attributes.label ? 'kui-select--with-label' : null, isScroll ? 'kui-select--scroll' : null, className);
  var setActiveHook = function setActiveHook(activeIndex) {
    activeHook = activeIndex;
    _setActiveHook(activeIndex);
  };
  var setInitialValue = function setInitialValue(value) {
    initialValue = value;
    _setInitialValue(value);
  };
  var onSelectListInit = function onSelectListInit(refs) {
    setItemsRefsHook(refs);
  };
  var openDropdown = function openDropdown() {
    var isFocus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    setIsOpenedHook(true);
    if (onOpen) onOpen();
    if (!editable || isFocus) {
      requestAnimationFrame(function () {
        var activeElement = document.activeElement;
        if (activeElement) {
          var parents = (0, _utils.getParentsClasses)(activeElement, [uniqueClass]);
          if (parents && parents.includes(uniqueClass)) return; // если фокус уже в селекте
        }
        focusSelectedItem();
      });
    }
  };
  var closeDropdown = function closeDropdown() {
    setIsOpenedHook(false);
    isOpened.current = false;
    if (!multiple && valueHook !== initialValue) {
      setActiveHook(active);
      setValue(initialValue);
    }
    if (onClose) onClose();
  };
  var calcDirection = function calcDirection() {
    var el = combinedRef.current.getBoundingClientRect();
    if (directionVertical === 'auto') {
      var isDirectionUp = el.top > window.innerHeight * 1 / 2;
      directionHook = isDirectionUp ? 'up' : 'down';
      var parentEl = combinedRef.current;
      var searchClassName = 'kui-search';
      if (parentEl && parentEl.className.includes(searchClassName + '--uplifted')) {
        parentEl.classList.add(searchClassName + '--' + directionHook);
      }
      setDirectionHook(directionHook);
    }
    if (portal) {
      var portalEl = portalSelector ? document.querySelector(portalSelector) : document.body;
      var portalScrollTop = (0, _utils.getParentsScrollTop)(portalEl);
      dropdownRef.current.style.top = 'unset';
      dropdownRef.current.style.bottom = 'unset';
      dropdownRef.current.style.left = 'unset';
      dropdownRef.current.style.right = 'unset';
      if (directionHorizontal === 'left') {
        dropdownRef.current.style.left = el.left + 'px';
      } else {
        dropdownRef.current.style.right = window.innerWidth - el.right + 'px';
      }
      if (directionHook === 'up') {
        dropdownRef.current.style.bottom = window.innerHeight - el.top + 'px';
      } else {
        dropdownRef.current.style.top = portalScrollTop + el.bottom + 'px';
      }
    }
    if (portal || isFitWindow) requestAnimationFrame(function () {
      // wait dropdownItem
      var maxHeight = Math.max(directionHook === 'up' ? el.top : window.innerHeight - (isDropdownUplifted ? el.top - UPLIFT_EXTRA_MARGIN : el.bottom), isDropdownUplifted ? combinedRef.current.offsetHeight * 3 : 0 // чтобы было видно хоть что-то, если isDropdownUplifted
      );
      var dropdownItem = dropdownRef.current.children[0];
      if (dropdownItem) dropdownItem.style.maxHeight = Math.round(maxHeight - _utils.SCREEN_PADDING * 2) + 'px';
    });
    setTimeout(function () {
      var dropdownItem = dropdownRef.current && dropdownRef.current.children[0];
      if (!dropdownItem) return;
      setScroll(dropdownItem.offsetHeight < dropdownItem.scrollHeight);
    }, 50);
  };
  var onDropdownMount = function onDropdownMount() {
    if (!dropdownRef.current) return;
    calcDirection();
    if (multiple && single) {
      dropdownRef.current.removeEventListener('click', onDropdownClick);
      dropdownRef.current.addEventListener('click', onDropdownClick);
    }
  };
  var focusSelectedItem = function focusSelectedItem() {
    var ariaSelected = dropdownRef.current && dropdownRef.current.querySelector('[tabindex]:not([tabindex="-1"]');
    if (ariaSelected) ariaSelected.focus();
  };
  var scrollList = function scrollList() {
    if (!isOpened.current &&
    // onAnimationEnd срабатывал после каждого скрола, а надо только 1 раз при открытии
    dropdownRef.current) {
      var dropdownItem = dropdownRef.current.children[0];
      if (!dropdownItem) return;
      if (itemsRefsHook[activeHook] && itemsRefsHook[activeHook].current) {
        var lines = Math.floor(dropdownItem.offsetHeight / itemsRefsHook[activeHook].current.offsetHeight);
        var center = Math.floor(lines / 2) * itemsRefsHook[activeHook].current.offsetHeight;
        dropdownItem.scrollTop = itemsRefsHook[activeHook].current.offsetTop - center; // centered active item
        isOpened.current = true;
      }
    }
  };
  var setValue = function setValue(value) {
    setValueHook(value);
  };
  attributes.onChange = function (e) {
    if (e.item) {
      // list item clicked
      if (multiple) {
        if (onChange) onChange(e);
      } else {
        inputRef.current.setFocus(); // return focus to input before dropdown hide
        setIsOpenedHook(false);
        isOpened.current = false;
        if (isUpdateValueOnChange) {
          setValue(e.item.text);
        }
        if (e.item.index !== activeHook) {
          setActiveHook(e.item.index);
        }
        if (onChange) onChange(e);
      }
    } else {
      // input changed
      if (e.target.value) setIsOpenedHook(true);
      setValue(e.target.value);
      if (onChange) onChange(e);
    }
  };
  attributes.onFocus = function (e) {
    if (onFocus) onFocus(e);
  };
  notBlurClasses = [].concat(_toConsumableArray(notBlurClasses), [uniqueClass, dropdownUniqueClass]);
  attributes.onBlur = function (e) {
    if (!document.hasFocus()) return;
    var classes = (0, _utils.getParentsClasses)(e.relatedTarget, notBlurClasses);
    for (var i = 0; i < notBlurClasses.length; i++) {
      if (classes.includes(notBlurClasses[i])) {
        return;
      }
    }
    closeDropdown();
    if (onBlur) onBlur(e);
  };
  attributes.onClick = function (e) {
    if (!isOpenedHook) {
      openDropdown();
    } else if (isCloseOnClick && valueHook === initialValue) {
      setIsOpenedHook(false);
      isOpened.current = false;
      if (onClose) onClose();
    }
    if (onClick) onClick(e);
  };
  var attributesSelectList = {
    active: activeHook,
    onChange: attributes.onChange,
    onSelectListInit: onSelectListInit
  };
  if (multiple || active === null) {
    attributesSelectList.fixActive = false;
  }
  if (children) {
    var childrenArray =
    // children could be string, we need array
    Array.isArray(children) ? children : [children];
    dropdownBody = React.Children.map(childrenArray, function (child) {
      if (!child || !child.type || !child.type.displayName || child.type.displayName !== 'SelectList') return child;
      list = React.Children.map(child.props.children, function (child) {
        if (!child || !child.props) return null;
        var classList = (0, _utils.ClassList)(child.props.className);
        var disabled = classList.includes('disabled');
        return /*#__PURE__*/React.cloneElement(child, {
          disabled: disabled
        });
      });
      return /*#__PURE__*/React.cloneElement(child, attributesSelectList);
    });
  } else if (options) {
    if (Array.isArray(options)) {
      list = options.map(function (option) {
        var li = multiple ? /*#__PURE__*/React.createElement(_checkbox.Checkbox, {
          key: option.value,
          checked: option.active,
          color: "light",
          value: option.value,
          onChange: function onChange() {
            return null;
          }
        }, option.text || option.value) : /*#__PURE__*/React.createElement("li", {
          key: option.value,
          value: option.value
        }, option.text || option.value);
        return li;
      });
    } else {
      var optionsObj = options;
      list = Object.keys(optionsObj).map(function (value) {
        return /*#__PURE__*/React.createElement("li", {
          key: value,
          value: value
        }, optionsObj[value]);
      });
    }
    dropdownBody = /*#__PURE__*/React.createElement(_ui.SelectList, attributesSelectList, list);
  }
  var findValue = function findValue(value) {
    return new Promise(function (resolve, reject) {
      if (!value || !list || !list.length) {
        reject();
        return;
      }
      var val = value.toLowerCase();
      React.Children.forEach(list, function (child, index) {
        var item = child.props.children.toLowerCase();
        if (item === val || item.includes(val)) {
          resolve({
            index: index,
            value: child.props.value,
            text: child.props.children
          });
        }
      });
      reject();
    });
  };
  attributes.onKeyDown = function (e) {
    if (!e) return;
    if (onKeyDown) onKeyDown(e);
    if (isOpenedHook && e.key === 'Escape') {
      e.stopPropagation();
      return closeDropdown();
    }
    if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
      e.preventDefault();
      if (!isOpenedHook) {
        openDropdown(true);
      }
      focusSelectedItem();
      return;
    }
    if (e.key === 'Enter') {
      if (!isOpenedHook) {
        return openDropdown(true);
      }
      if (onEnter) onEnter(e);
      /**
       * сначала была задумка: пишешь в инпуте - в дропдауне подсвечивается подходящий айтем. похожим образом ведут себя системные селекты
       * но потом в канбане появился searchSelect, он больше похож на material
       */
      // if (activeHook === null) {
      //     findValue(e.target.value)
      //         .then((found: ISelectActiveProps) => {
      //             setActiveHook(found.index);
      //             onActiveChanged(found.index);
      //             if (onChange) onChange(Object.assign({}, e, {item: found}));
      //         })
      //         .catch(() => {
      //             setActiveHook(null);
      //         });
      // } else if (list[activeHook]) {
      //     if (
      //         onChange &&
      //         list[activeHook].props
      //     ) {
      //         onChange(Object.assign({}, e, {item: list[activeHook].props}));
      //     }
      //     onActiveChanged(activeHook);
      // }
      if (!multiple && isCloseOnEnter) {
        closeDropdown();
      }
    }
  };
  var onActiveChanged = function onActiveChanged() {
    var activeNew = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    if (activeNew === null) activeNew = active;
    if (activeNew === null || !list.length || !list[activeNew]) return;
    if (list[activeNew].props && list[activeNew].props.children) {
      setInitialValue(list[activeNew].props.children);
      setValue(list[activeNew].props.children);
    }
  };
  var onDropdownKeyDown = function onDropdownKeyDown(e) {
    if (!e) return;
    if (e.key === 'Escape' || multiple && single && e.key === 'Enter' // чекбоксы меняются пробелом, а на Enter нужно применить и закрыть дропдаун
    ) {
      inputRef.current.setFocus(); // return focus to input before dropdown hide
      closeDropdown();
    }
  };
  function onDropdownClick(e) {
    var classes = (0, _utils.getParentsClasses)(e.target, [_selectListItem.SELECT_LIST_ITEM_CLASS, _selectList.SELECT_LIST_CLASS]);
    if (classes.includes(_selectListItem.SELECT_LIST_ITEM_CLASS)) {
      timer.current = setTimeout(closeDropdown, 100); // close after onChange
    }
  }
  React.useEffect(function () {
    onActiveChanged();
    var dropdownRefCurrent = dropdownRef.current;
    return function () {
      if (dropdownRefCurrent) dropdownRefCurrent.removeEventListener('click', onDropdownClick);
      if (timer.current) clearTimeout(timer.current);
    };
  }, []);
  React.useEffect(function () {
    scrollList();
    if (onActiveChange) onActiveChange(activeHook);
  }, [activeHook]);
  React.useEffect(function () {
    setActiveHook(active);
    if (!multiple) {
      onActiveChanged();
    }
  }, [active, options]);
  var classNameDropdown = (0, _utils.ClassNames)('kui-select__dropdown', dropdownUniqueClass, dropdownClassName);
  var dropdownElement = dropdownBody ? /*#__PURE__*/React.createElement(_ui.Dropdown, {
    className: classNameDropdown,
    directionVertical: directionHook,
    directionHorizontal: directionHorizontal,
    isFitWindow: isFitWindow,
    opened: isOpenedHook,
    ref: dropdownRef,
    tabIndex: -1,
    portal: portal,
    onAnimationEnd: scrollList,
    onBlur: attributes.onBlur,
    onDidMount: onDropdownMount,
    onKeyDown: onDropdownKeyDown
  }, dropdownBody) : null;
  var dropdownPortal = readOnly || disabled ? null : portal ? /*#__PURE__*/React.createElement(_portal.Portal, {
    id: portalId,
    selector: portalSelector
  }, dropdownElement) : dropdownElement;
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    ref: combinedRef
  }, /*#__PURE__*/React.createElement(_ui.Input, _extends({
    autosize: false,
    color: color,
    disabled: disabled,
    readOnly: readOnly || !editable,
    ref: inputRef,
    value: valueHook,
    variant: variant,
    "aria-haspopup": true,
    "aria-expanded": isOpenedHook
  }, attributes)), dropdownPortal);
});
exports.Select = Select;
Select.defaultProps = {
  active: null,
  color: null,
  directionVertical: 'auto',
  directionHorizontal: 'left',
  disabled: false,
  editable: false,
  isCloseOnClick: true,
  isCloseOnEnter: true,
  multiple: false,
  notBlurClasses: [],
  opened: false,
  options: null,
  single: true,
  onChange: function onChange() {
    return undefined;
  },
  onEnter: function onEnter() {
    return undefined;
  },
  onOpen: function onOpen() {
    return undefined;
  },
  onClose: function onClose() {
    return undefined;
  }
};
Select.displayName = 'Select';